import React from 'react';
import { StackedBarData } from '../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Tab, TabList, TabPanel, Tabs } from '../../../../../../CommonComponents/OPL/Tab';
import { BucketData } from '../../useAssetBucketingResults';
import { BucketTab } from './BucketTab/BucketTab';
import { OverviewTab } from './OverviewTab/OverviewTab';

interface Props {
  buckets: BucketData[];
  networthAmount?: number;
  networthMakeup: StackedBarData;
  onClose(): void;
}

export const FullBreakdown: React.FC<Props> = ({
  buckets,
  networthAmount,
  networthMakeup,
  onClose,
}) => {
  return (
    <Modal isOpen onRequestClose={onClose} contentLabel="PLD full breakdown" centered={false}>
      <ModalHeader>Your Net Worth Makeup</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <Tabs>
        <TabList px="24" mb="24">
          {['Overview', ...buckets.map(bucket => bucket.title)].map(tab => (
            <Tab key={tab}>{tab}</Tab>
          ))}
        </TabList>

        <TabPanel>
          <OverviewTab
            networthAmount={networthAmount}
            networthMakeup={networthMakeup}
            buckets={buckets}
          />
        </TabPanel>

        {buckets.map(bucket => (
          <TabPanel key={bucket.title}>
            <BucketTab data={bucket} />
          </TabPanel>
        ))}
      </Tabs>
    </Modal>
  );
};
